// extracted by css-extract-rspack-plugin
export default {"Wrapper":"SidePanelContainer_Wrapper__5LsP1","Filler":"SidePanelContainer_Filler__qmboJ","StickyContainer":"SidePanelContainer_StickyContainer__43W0l"};